<div>
    <button type="submit" mat-raised-button [disabled]="!isFormValid()" [color]="color$ | async">{{title$ | async}}</button>
</div>
